import Vue from "vue";
import {
  Pagination,
  Dialog,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Input,
  InputNumber,
  Autocomplete,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  OptionGroup,
  Button,
  Table,
  TableColumn,
  DatePicker,
  Popover,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Tabs,
  TabPane,
  Tag,
  Tree,
  Alert,
  Icon,
  Row,
  Col,
  Upload,
  Progress,
  Spinner,
  Badge,
  Card,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Cascader,
  Image,
  CascaderPanel,
  Loading,
  MessageBox,
  Message,
  Divider,
  Drawer,
  Scrollbar,
  InfiniteScroll,
  Popconfirm,
  Descriptions,
  DescriptionsItem,
  Timeline,
  TimelineItem,
  Step,
  Steps,
  Backtop,
  Slider,
  Skeleton,
  SkeletonItem,
  ColorPicker,
} from "element-ui";

import CollapseTransition from "element-ui/lib/transitions/collapse-transition";

Vue.component(CollapseTransition.name, CollapseTransition);
Vue.use(InfiniteScroll);
Vue.use(Drawer);
Vue.use(Divider);
Vue.use(Scrollbar);
Vue.use(Pagination);
Vue.use(Dialog);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(MenuItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Autocomplete);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Button);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(DatePicker);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Tag);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Upload);
Vue.use(Progress);
Vue.use(Spinner);
Vue.use(Badge);
Vue.use(Card);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Cascader);
Vue.use(Image);
Vue.use(Popconfirm);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Backtop);

Vue.use(Steps);
Vue.use(Step);
Vue.use(CascaderPanel);
Vue.use(Slider);
Vue.use(Skeleton);
Vue.use(SkeletonItem);
Vue.use(ColorPicker);
Vue.use(Loading.directive);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;
Vue.prototype.$ELEMENT = { size: "small" };

// 改写element消息弹框，让多个相同弹框时只弹一个
let messageInstance = null;
const resetMessage = (option) => {
  if (messageInstance) {
    messageInstance.close();
  }
  messageInstance = Message(option);
};

["error", "success", "info", "warning"].forEach((type) => {
  resetMessage[type] = (options) => {
    if (typeof options === "string") {
      options = {
        message: options,
      };
    }
    options.type = type;
    return resetMessage(options);
  };
});

export const Messages = resetMessage;

function msgHint(message, duration = 2000) {
  return Message({
    message,
    iconClass: "el-icon-time",
    customClass: "customHint",
    duration,
  });
}

Vue.prototype.$msgHint = msgHint;
